var _RefComponentsNamespace_instances, _RefComponentsNamespace_getFirstRefComponent;
import { __classPrivateFieldGet } from "tslib";
import { PrivateAPINamespace } from '../PrivateAPINamespace';
import { createRefComponentsError, RefComponentsNamespaceErrorCode, } from './errors';
import { findComponentBySelector } from './helpers';
export class RefComponentsNamespace extends PrivateAPINamespace {
    constructor() {
        super(...arguments);
        _RefComponentsNamespace_instances.add(this);
    }
    isRefComponent(compRef) {
        return (this.ps.ds.components.getType(compRef) ===
            'wysiwyg.viewer.components.RefComponent');
    }
    findComponentBySelector(compRef, selector) {
        const component = findComponentBySelector(this.ps.ds, compRef, selector);
        if (!component) {
            throw createRefComponentsError(RefComponentsNamespaceErrorCode.UnableToFindComponentBySelector)
                .withComponentId(compRef.id)
                .withSelector(selector);
        }
        return component.componentRef;
    }
    async hideReferredComponent(applicationId, compRef) {
        this.ps.ds.runInContext(applicationId, () => {
            return this.ps.ds.components.remove(compRef);
        });
        await this.waitForChangesApplied();
    }
    async showReferredComponent(applicationId, compRef) {
        this.ps.ds.runInContext(applicationId, () => {
            return this.ps.ds.components.refComponents.unGhostifyComponent(compRef);
        });
        await this.waitForChangesApplied();
    }
    async hideBySelector(applicationId, rootComp, selector) {
        const compRef = this.findComponentBySelector(rootComp, selector);
        await this.hideReferredComponent(applicationId, compRef);
    }
    async showBySelector(applicationId, rootComp, selector) {
        const compRef = this.findComponentBySelector(rootComp, selector);
        await this.showReferredComponent(applicationId, compRef);
    }
    async getHiddenComponents(refComponentRef, options) {
        if (!this.isRefComponent(refComponentRef)) {
            throw createRefComponentsError(RefComponentsNamespaceErrorCode.UnableToGetHiddenNoneRefComponents, 'Unable to get hidden none ref components for the given component').withComponentId(refComponentRef.id);
        }
        const refComponents = [refComponentRef];
        if (options?.includeNested) {
            const children = this.ps.ds.deprecatedOldBadPerformanceApis.components.getChildren(refComponentRef, true);
            children.forEach((compRef) => {
                if (this.isRefComponent(compRef)) {
                    refComponents.push(compRef);
                }
            });
        }
        return refComponents.reduce((acc, compRef) => {
            const ghostsComponents = this.ps.ds.components.refComponents.getAllGhostRefComponentsPrimaryConnection(compRef);
            if (ghostsComponents) {
                Object.keys(ghostsComponents).forEach((ghostId) => {
                    acc.push({
                        componentRef: this.ps.ds.components.get.byId(ghostId),
                        role: ghostsComponents[ghostId]?.role,
                    });
                });
            }
            return acc;
        }, []);
    }
    async getHiddenComponentRoles(rootComp, options) {
        const refComponent = __classPrivateFieldGet(this, _RefComponentsNamespace_instances, "m", _RefComponentsNamespace_getFirstRefComponent).call(this, rootComp);
        const hiddenComponents = await this.getHiddenComponents(refComponent, options);
        return hiddenComponents.map((hiddenComponent) => hiddenComponent.role);
    }
    async findHiddenComponentByRole(rootComp, role, options) {
        const refComponent = __classPrivateFieldGet(this, _RefComponentsNamespace_instances, "m", _RefComponentsNamespace_getFirstRefComponent).call(this, rootComp);
        const hiddenComponents = await this.getHiddenComponents(refComponent, options);
        const hiddenComponent = hiddenComponents.find((component) => component.role === role);
        return hiddenComponent?.componentRef || null;
    }
    async isHiddenBySelector(rootComp, selector) {
        const bySelectorComponent = findComponentBySelector(this.ps.ds, rootComp, selector);
        if (!bySelectorComponent) {
            return false;
        }
        const allHiddenComponents = await this.getHiddenComponentRoles(rootComp, {
            includeNested: true,
        });
        return allHiddenComponents.some((hiddenComponent) => hiddenComponent === bySelectorComponent.role);
    }
    setProps(compRef, props) {
        this.ps.ds.appStudioWidgets.props.set(compRef, props);
    }
    getProps(compRef) {
        return this.ps.ds.appStudioWidgets.props.get(compRef);
    }
}
_RefComponentsNamespace_instances = new WeakSet(), _RefComponentsNamespace_getFirstRefComponent = function _RefComponentsNamespace_getFirstRefComponent(compRef) {
    if (this.isRefComponent(compRef)) {
        return compRef;
    }
    const refComponent = this.ps.ds.components.refComponents.getRefHostCompPointer(compRef);
    if (!refComponent) {
        throw createRefComponentsError(RefComponentsNamespaceErrorCode.UnableToFindRefComponent, 'Unable to find refComponent for the root component').withRootComponentId(compRef.id);
    }
    return refComponent;
};
RefComponentsNamespace.namespace = 'refComponents';
//# sourceMappingURL=RefComponentsNamespace.js.map